export enum I18nKeys {
  Creating = 'creating',
  Create = 'create',
  Edit = 'edit',
  Disable = 'disable',
  Enable = 'enable',
  Add = 'add',
  Cancel = 'cancel',

  Name = 'name',
  ClientId = 'clientId',
  EntityId = 'entityId',
  ExternalIdField = 'externalIdField',
  ExternalId = 'externalId',
  Id = 'id',
  SelectExternalIdField = 'selectExternalIdField',
  Uid = 'uid',
  Email = 'email',
  EmailAddress = 'emailAddress',
  PhoneNumber = 'phoneNumber',
  RpEntityId = 'rpEntityId',
  SsoUrl = 'ssoUrl',
  UserType = 'userType',
  SelectUserType = 'selectUserType',

  Staff = 'staff',
  Shoppers = 'shoppers',
  Issuer = 'issuer',

  Tenants = 'tenants',
  TenantsNameRequiredError = 'nameRequiredError',
  TenantsAliasRequiredError = 'aliasRequiredError',
  AdminEmailRequiredError = 'adminEmailRequiredError',
  Permissions = 'permissions',
  PermissionsIdRequiredError = 'idRequiredError',
  PermissionsAliasRequiredError = 'aliasRequiredError',
  PermissionsDescriptionRequiredError = 'descriptionRequiredError',
  GroupList = 'groupList',
  GroupListNameRequiredError = 'nameRequiredError',
  GroupListDescriptionRequiredError = 'descriptionRequiredError',
  EmailRequiredError = 'emailRequiredError',

  //  Identity Providers
  IdentityProviders = 'identityProviders',
  IdentityProviderCreate = 'identityProviders.create',
  IdentityProviderNameRequiredError = 'identityProviders.nameRequiredError',
  IdentityProviderCertificatesRequiredError = 'identityProviders.certificatesRequiredError',
  IdentityProviderClientIdRequiredError = 'identityProviders.clientIdRequiredError',
  IdentityProviderEntityIdRequiredError = 'identityProviders.entityIdRequiredError',
  IdentityProviderExternalIdRequiredError = 'identityProviders.externalIdRequiredError',
  IdentityProviderRPEntityIdRequiredError = 'identityProviders.rpEntityIdRequiredError',
  IdentityProviderUserTypeRequiredError = 'identityProviders.userTypeRequiredError',
  IdentityProviderIssuerRequiredError = 'identityProviders.issuerRequiredError',
  IdentityProviderPromptRequiredError = 'identityProviders.promptRequiredError',
  Prompt = 'prompt',
  SetPrimaryIdentityProvider = 'identityProviders.setPrimary',
  SsoUrlIssuerRequiredError = 'identityProviders.ssoUrlRequiredError',
  UnsetPrimaryIdentityProvider = 'identityProviders.unsetPrimary',

  //  Profile
  Profile = 'profile',
  MyPermissions = 'effectivePermissions',
  ResetPassword = 'resetPassword',
  CurrentPassword = 'currentPassword',
  CurrentPasswordIncorrect = 'currentPasswordIncorrect',
  NewPassword = 'newPassword',
  UserProfileId = 'userProfileId',

  //  Built-In Roles
  BuiltInRoles = 'builtInRoles',

  //  User Search
  UserSearch = 'userSearch',
  MyGroups = 'myGroups',

  //  Custom Roles
  CustomRolesFixedBindings = 'customRolesFixedBindings',
  CustomRolesFixedBindingsEmpty = 'customRolesFixedBindingsEmpty',
  CustomRolesAddFixedBindings = 'customRolesAddFixedBindings',
  CustomRolesFixedBindingsDescription = 'customRolesFixedBindingsDescription',
  CustomRolesSelectResources = 'customRolesSelectResources',
  CustomRolesSelectResourcesPlaceholder = 'customRolesSelectResourcesPlaceholder',
  CustomRolesLoadResourcesError = 'customRolesLoadResourcesError',
  CustomRolesFixedBindingAddedSuccess = 'customRolesFixedBindingAddedSuccess',
  CustomRolesFixedBindingsAddedSuccess = 'customRolesFixedBindingsAddedSuccess',
  CustomRolesFixedBindingRemoved = 'customRolesFixedBindingRemoved',
  CustomRolesUpdatedSuccess = 'customRolesUpdatedSuccess',
  CustomRolesUpdateError = 'customRolesUpdateError',
}
